import { Download } from 'lucide-react';
import { PIKKO_APP_DEEPLINK } from '../../../utils/appStoreRedirect';

export const PikkoJackpotDownloadButton = ({ isReminder, target }) => (
  <button
    type="button"
    className="purchase-button footer-cart-button bottom-btn-shadow w-full"
    style={{
      display: 'flex', flexDirection: 'row', justifyContent: 'center', fontSize: '17px',
    }}
    onClick={() => window.open(PIKKO_APP_DEEPLINK, '_blank', 'noopener')}
  >
    <Download size={20} strokeWidth={3} />
    {isReminder ? `Récupérer mes ${Math.round(target)}€` : "Télécharger l'application"}
  </button>
);
